const { APP_DOMAIN } = Config;

// TODO! use axios
// import axios from "axios";

import GetStore from "../store";
import { setShowUnauthorized } from "../store/panel.js";

// Helpers ------------------------------------------------------------------ //
async function Undup(key, promise, delay = 1000) {
    Undup._waits = Undup._waits ?? {};

    if (!Undup._waits[key]) {
        Undup._waits[key] = {
            timeout: setTimeout(() => delete Undup._waits[key], delay),
            promise: promise(),
        };
    }

    return Undup._waits[key].promise;
}

async function Packer(key, value, promise, delay = 100) {
    Packer._pack = Packer._pack || {};

    const x = (Packer._pack[key] = Packer._pack[key] || {});
    x.timeout && clearTimeout(x.timeout);
    x.values = x.values || [];
    x.values.push(value);
    x.promises = x.promises || [];

    x.timeout = setTimeout(() => {
        promise(x.values)
            .then(data => {
                for (const { resolve } of x.promises) {
                    resolve(data);
                }
            })
            .catch(error => {
                for (const { reject } of x.promises) {
                    reject(error);
                }
            })
            .then(() => {
                x.timeout = 0;
                x.values = [];
                x.promises = [];
            });
    }, delay);

    return new Promise((resolve, reject) => x.promises.push({ resolve, reject }));
}

// -------------------------------------------------------------------------- //
export function Send(url, body, abort = {}) {
    // console.warn(`[part-panel/api.js] Send() ${url}`);

    body = body ? JSON.stringify(body) : null;

    const ac = abort || new AbortController();

    return fetch(url, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body,
        signal: ac.signal,
    })
        .then(r => {
            if (r.status === 401) {
                GetStore().dispatch(setShowUnauthorized(true));
                return {};
            } else if (r.status === 403) {
                return {};
            } else if (r.status === 504) {
                return { errors: [{ error: "TIMEOUT" }] };
            }

            return r.json && r.json();
        })
        .catch(e => {
            if (e.message === "Load failed") {
                return;
            }

            console.warn(`[Send()] ${url}`, e);
        });
}

export function SendFD(url, fd, abort = {}) {
    // console.warn(`[part-panel/api.js] SendFD() ${url}`);

    let signal = abort?.signal;

    return fetch(url, {
        method: "POST",
        body: fd,
        signal,
    })
        .then(r => r.json())
        .catch(e => {
            throw new Error(e);
        });
}

// AddWebsite --------------------------------------------------------------- //
export function AddWebsiteCheck() {
    // return Promise.resolve({ ok: true });

    // TODO!
    return Send("/add-website/check");
}

// Wizard ------------------------------------------------------------------- //
export function WizardSave(data, abort = {}) {
    return Send("/wizard", { data }, abort);
}

export function WizardLoad() {
    return Send("/wizard");
}

export function WizardClear() {
    return Send("/wizard", { data: null });
}

// SVG ---------------------------------------------------------------------- //
export function SvgBg(primaryHex = "", secondaryHex = "", info = {}) {
    return Send("/svg-bg/gen", { primaryHex, secondaryHex, info }).catch(e => console.warn(e));
}

export function SvgBgDemo(primaryHex = "", secondaryHex = "", info = {}) {
    return Send("/svg-bg/data-url", { primaryHex, secondaryHex, info }).catch(e => console.warn(e));
}

export function SvgBgSign(name = "") {
    return Send("/svg-bg/sign", { name });
}

export function SvgBgUnsign(name = "") {
    return Send("/svg-bg/unsign", { name });
}

export function SvgBgUpdate(name = "", primaryHex = "", secondaryHex = "", info = {}) {
    return Send("/svg-bg/gen", { name, primaryHex, secondaryHex, info }).catch(e => console.warn(e));
}

// Compile ------------------------------------------------------------------ //
export function CompileGenerate({ variables, structure }) {
    return Send("/compile/generate", { variables, structure }).then(res => {
        if (!res?.ok) {
            throw new Error(`Error while structure generate`);
        }

        return res;
    });
}

export function CompileRender(domain) {
    return Send("/compile/render", { domain }).then(res => {
        if (!res?.ok) {
            throw new Error(`Error while project rendering`);
        }
    });
}

export function CompileUpdateProject(data) {
    return Send("/compile/update-project", data).then(res => {
        if (!res?.ok) {
            if (res?.errors) {
                throw res.errors;
            }

            throw new Error(`Error while project update`);
        }
    });
}

export function CompileDelete(domain) {
    return Send("/compile/delete", { domain }).then(res => {
        if (!res?.ok) {
            throw new Error(`Error while delete render`);
        }
    });
}

// Plan --------------------------------------------------------------------- //
export function PlanList() {
    return Undup("/plan/list", () => Send("/plan/list"), 1000);
}

// Account ------------------------------------------------------------------ //
export function AccountSet({ id_plan, firstname, lastname, email, password, promocode, recaptcha }) {
    return Send("/account/set", { id_plan, firstname, lastname, email, password, promocode, recaptcha });
}

export function AccountSetPassword({ password }) {
    return Send("/account/set-password", { password });
}

export function AccountAuth({ email, password }) {
    return Send("/account/auth", { email, password });
}

export function AccountCheck() {
    return Send("/account/check");
}

export function AccountDel() {
    return Send("/account/del");
}

export function HelpMessageSend({ subject, helpMessage }) {
    return Send("/account/support", { subject, helpMessage });
}

export function AccountLimits() {
    return Send("/account/limits");
}

// Project ------------------------------------------------------------------ //
export function ProjectList(filter = { field: "id", order: "asc" }) {
    return Send("/project/list", { filter }).then(res => {
        if (!res?.ok) {
            throw new Error(`Error while /project/list. =(`);
        }

        return res;
    });
}

export function ProjectSet(project) {
    return Send("/project/set", project);
}

export function ProjectFileUpload(fd) {
    return SendFD("/project/file-upload", fd);
}

export function ProjectUpdate(project) {
    if (!project.id_project) {
        throw new Error("ProjectUpdate: id_project");
    }

    return Send("/project/set", project).then(res => {
        if (!res?.ok) {
            throw new Error(`Error while /project/set (update). =(`);
        }

        return res;
    });
}

export function ProjectDelete(id_project) {
    return Send("/project/del", { id_project });
}

export function ProjectPaypalSet(id_project, settings) {
    return Send("/project/paypal-set", { id_project, settings });
}

export function ProjectPaypalGet(id_project) {
    return Send("/project/paypal-get", { id_project });
}

export function ProjectPaypalSetup(id_project) {
    return Send("/project/paypal-setup", { id_project });
}

export async function ProjectStats(id_project) {
    return (
        await Packer(
            "ProjectStats",
            { id_project },
            values =>
                Send(
                    "/project/stats", //
                    {
                        id_project: values
                            .map(({ id_project }) => id_project)
                            .asc()
                            .uniq(),
                    }
                ),
            100
        )
    )?.stats?.[id_project];
}

export function ProjectCanConversion() {
    return Send("/project/can-conversion", {});
}

export async function ProjectConversionStats(domain) {
    const result = await Packer(
        "ProjectConversionStats",
        { domain },
        values =>
            Send(
                "/project-conversion/stats", //
                {
                    domain: values
                        .map(({ domain }) => domain)
                        .asc()
                        .uniq(),
                }
            ),
        100
    );

    if (result.stats?.[domain]) {
        return result.stats?.[domain];
    } else if (result.errors?.[domain]) {
        return result.errors?.[domain];
    } else {
        console.warn(result.stats);
    }
}

export async function ProjectConversionStatus(domain) {
    const result = await Packer(
        "ProjectConversionStatus",
        { domain },
        values =>
            Send(
                "/project-conversion/status", //
                {
                    domain: values
                        .map(({ domain }) => domain)
                        .asc()
                        .uniq(),
                }
            ),
        100
    );

    if (result?.[domain]?.status) {
        return result?.[domain];
    } else if (result.status?.[domain]) {
        return result.status?.[domain];
    } else if (result.errors?.[domain]) {
        return result.errors?.[domain];
    } else {
        // console.warn(domain, result);
    }
}

export async function ProjectAiPage(id_project) {
    const response = await Send("/project/ai-page", { id_project });
    return response;
}

export async function ProjectAiEcommerce(id_project) {
    const response = await Send("/project/ai-ecommerce", { id_project });
    return response;
}

export async function ProjectAiGoogleAds(id_project) {
    const response = await Send("/project/ai-google-ads", { id_project });
    return response;
}

// Page --------------------------------------------------------------------- //
export function PageSet(id_project, structure, id_page = null) {
    return Send("/page/set", { id_project, structure, id_page }).then(res => {
        if (!res?.ok) {
            throw new Error(`Error while /page/set. =(`);
        }

        return res;
    });
}

export function PageUpdate(id_page, structure) {
    return Send("/page/set", { id_page, structure }).then(res => {
        if (!res?.ok) {
            throw new Error(`Error while /page/set (update). =(`);
        }

        return res;
    });
}

// Uploads ------------------------------------------------------------------ //
export function UploadFiles() {
    const base64FileList = [];

    (function recursion(_variables) {
        if (_variables?.constructor?.name === "Object") {
            if (_variables?.file?.dataUrlBase64) {
                base64FileList.push({
                    parent: _variables,
                    file: _variables?.file,
                });
            } else {
                for (const key in _variables) {
                    recursion(_variables[key]);
                }
            }
        } else if (Array.isArray(_variables)) {
            for (const value of _variables) {
                recursion(value);
            }
        }
    })(props.variables);

    return Promise.all(
        base64FileList.map(({ parent, file }) => {
            return fetch(file.dataUrlBase64)
                .then(r => r.blob())
                .then(blob => {
                    const fd = new FormData();
                    fd.set("id_project", Project.id_project);
                    fd.set("file", new File([blob], file.name, { type: file.type }));

                    return fetch("/project/file-upload", {
                        method: "POST",
                        body: fd,
                    })
                        .then(r => r.json())
                        .then(res => {
                            if (!res?.ok) {
                                throw new Error(`Error while uploading file - ${file.name}`);
                            }

                            parent.src = `/u/${res.webp}`;

                            if (parent.file.type) {
                                delete parent.file.type;
                            }

                            if (parent.file.dataUrlBase64) {
                                delete parent.file.dataUrlBase64;
                            }

                            return res;
                        });
                });
        })
    ).then((/* results */) => {
        return true;
    });
}

// DNSCheck ----------------------------------------------------------------- //
export function DNSCheck(domain = APP_DOMAIN) {
    return Send(`/dns-check`, { domain });
}

// Payment ------------------------------------------------------------------ //
export function GetPaymentForm(system, options) {
    return Send(`/payment/pay/`, { system, options });
}

export function SetPayment(system = "", id) {
    return Send(`/payment/set/`, { id_plan: id, system });
}

export function CancelSubscription(system = "") {
    return Send("/payment/unsubscribe-account", { system });
}

// Google ------------------------------------------------------------------- //
export function GoogleAdsAdd(id, data) {
    return Send("/google/ads-add", { id, data });
}

export function GoogleAdsDel(id_project, id_campaign) {
    return Send("/google/ads-del", { id_project, id_campaign });
}

export function GetGoogleAdsCampaign(id) {
    return Send("/google/get-ads", { id });
}

export function GooglePayment(system, options) {
    return Send("/payment/pay-google-ads", { system, options });
}

export function GoogleGetTargetConstants() {
    return Send("/google/get-target-constants", {});
}
